/* unplugin-vue-components disabled */import { render } from "./Premiere.vue?vue&type=template&id=36b7c2bd&scoped=true"
import script from "./Premiere.vue?vue&type=script&lang=js"
export * from "./Premiere.vue?vue&type=script&lang=js"

import "./Premiere.vue?vue&type=style&index=0&id=36b7c2bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b7c2bd"]])

export default __exports__